export const downloadBlob = (blob: Blob) => {
  const downloadURL = URL.createObjectURL(blob);

  const anchorElement = document.createElement('a');

  document.body.appendChild(anchorElement);

  anchorElement.style.display = 'none';

  anchorElement.href = downloadURL;

  anchorElement.target = '_blank';

  anchorElement.click();

  window.URL.revokeObjectURL(downloadURL);
};
